import React from "react";
import EnrollmentForm from "../components/EnrollmentForm";
import "./Enroll.css";

const Enroll = () => {
  return (
    <div className="enroll-page">
      {/* Hero Section */}
      <section className="enroll-hero section">
        <div className="container">
          <h1 className="section-title">Enroll in a Course</h1>
          <p className="section-subtitle">
            Fill out the form below to apply for any of our training
            programs. Our team will contact you within 24 hours to confirm
            your enrollment and next steps.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="enroll-content">
          {/* Enrollment Form */}
          <section className="enroll-form-section">
            <h2>Enrollment Application</h2>
            <p>
              Fields marked with an asterisk (*) are required. Once
              submitted, your application is sent straight to our admissions
              team.
            </p>
            <EnrollmentForm />
          </section>

          {/* Sidebar Info */}
          <aside className="enroll-info-section">
            <div className="info-card">
              <h3>Why Enroll With Us?</h3>
              <ul className="info-list">
                <li>Bursaries covering 50%-100% of tuition available</li>
                <li>Comprehensive manual books included</li>
                <li>Assistance with voluntary job placement</li>
                <li>Online & physical training options worldwide</li>
              </ul>
            </div>

            <div className="info-card highlight-card">
              <h3>What Happens Next?</h3>
              <ol className="info-steps">
                <li>Submit your enrollment application</li>
                <li>Our admissions team reviews your details</li>
                <li>We contact you within 24 hours</li>
                <li>Confirm your start date & begin training</li>
              </ol>
            </div>

            <div className="info-card">
              <h3>Prefer to Talk to Us Directly?</h3>
              <p>
                <a href="https://wa.me/+260773393067">
                  WhatsApp: +260 773393067
                </a>
              </p>
              <p>
                <a href="mailto:info@passioncare4uglobal.com">
                  info@passioncare4uglobal.com
                </a>
              </p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Enroll;
